// src/pages/Dashboard/sections/network-tabs/SearchTab.jsx
import React from 'react';

/**
 * Search Tab Component
 * Allows searching for nodes in the network
 */
const SearchTab = ({
  searchQuery,
  setSearchQuery,
  searchResults,
  isSearching,
  handleSearch,
  formatWalletAddress
}) => {
  return (
    <div className="network-search-container">
      <div className="search-controls">
        <h3>Search Network</h3>
        <form onSubmit={handleSearch} className="search-form">
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="Search by wallet address, username, or node ID"
            className="search-input"
          />
          <button 
            type="submit" 
            className="search-button"
            disabled={isSearching || !searchQuery.trim()}
          >
            {isSearching ? 'Searching...' : 'Search'}
          </button>
        </form>
      </div>
      
      {searchResults.length > 0 ? (
        <div className="search-results">
          <h4>Search Results</h4>
          <div className="table-responsive">
            <table className="network-table">
              <thead>
                <tr>
                  <th>Node ID</th>
                  <th>Name</th>
                  <th>Wallet Address</th>
                  <th>Tier</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {searchResults.map((node) => (
                  <tr key={node.id}>
                    <td className="node-col">{node.id}</td>
                    <td>{node.user_name || 'N/A'}</td>
                    <td className="wallet-col">{formatWalletAddress(node.wallet_address)}</td>
                    <td>{node.tier_name || 'Standard'}</td>
                    <td>
                      <span className={`status-badge ${node.status?.toLowerCase() || 'active'}`}>
                        {node.status || 'Active'}
                      </span>
                    </td>
                    <td>
                      <button className="action-btn">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10 12a2 2 0 1 0 4 0 2 2 0 0 0-4 0zm0-6a2 2 0 1 0 4 0 2 2 0 0 0-4 0zm0 12a2 2 0 1 0 4 0 2 2 0 0 0-4 0z" fill="currentColor"/>
                        </svg>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : searchQuery && !isSearching ? (
        <div className="no-data-message">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <p>No nodes found matching your search query.</p>
        </div>
      ) : !searchQuery ? (
        <div className="no-data-message">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M21 21L16.65 16.65" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <p>Enter a search term to find nodes in your network.</p>
        </div>
      ) : null}
    </div>
  );
};

export default SearchTab;
